import Vue from 'vue'
import Vuex from 'vuex'
import userService from '@/services/api/services/userService'
import { Role } from '@/constants/constants'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    shopOrigin: null,
    user: null
  },
  getters: {
    roles(state) {
      return state.user ? state.user.roles : [Role.Guest]
    }
  },
  mutations: {
    setShopOrigin(state, payload) {
      state.shopOrigin = payload
    },
    setUser(state, payload) {
      state.user = payload
    }
  },
  actions: {
    async setShopOrigin({ commit }) {
      const shopOrigin = new URLSearchParams(window.location.search).get('shop')
      commit('setShopOrigin', shopOrigin)
    },
    async authenticate({ commit }) {
      const user = await userService.findMe().catch(() => null)
      if (user) {
        const userAttributes = {
          name: user.shopOrigin,
          shopOrigin: user.shopOrigin,
          email: user.details.email,
          appName: process.env.VUE_APP_NAME,
          environment: process.env.VUE_APP_ENV
        }
        Vue.prototype.$segment.identify(user.id, userAttributes)
        Vue.prototype.$honeybadger.setContext({ userId: user.id, ...userAttributes })
      }
      commit('setUser', user)
      return user
    }
  }
})
